import { Box, Chip } from "@mui/material";
import React, { FC } from "react";

type Props = {
  label: string,
  text: string,
  backgroundColor?: React.CSSProperties["backgroundColor"],
  color?: React.CSSProperties["color"]
}

export const BaseChip: FC<Props> = ({
  label,
  text,
  backgroundColor = "#52a869",
  color = "white"
}) => {
  return (
    <Box
      display="flex"
      gap="10px"
      alignContent="center"
      alignItems="center"
      style={{
        border: `1px solid ${backgroundColor}`,
        borderRadius: "50px",
        paddingRight: "10px",
        height: "24px",
      }}
    >
      <Chip size="small" label={label} style={{ backgroundColor, color, minWidth: "4.5rem", fontSize: "0.75rem" }} />
      <span style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: "0.8rem"
      }}
      >
        {text}
      </span>
    </Box>
  );
};